import React from 'react';
import './ProfileCard.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faInstagram, faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';

const ProfileCard = () => {
  return (
    <div className="profile-card">
      <div className="cooontent">
        <div className="left">
          <div className="blog-header">Your Blog</div>
          <div className="blog-post purplee "></div>
          <div className="blog-post pink"></div>
          <div className="blog-post purplee"></div>
        </div>
        <div className="right">
          <div className="profile-info">
            <div className="profile-pic"></div>
            <div className="profile-name">Shubham Khandelwal</div>
            <div className="followers">25 Followers</div>
            <div className="bio">
              DevOps || Passionate about cloud computing and its power to transform busignupesses.
              By night, I share my knowledge and insights on Medium.
            </div>
            <div className="rating">
              <span>⭐⭐⭐⭐</span>
              <button className="edit-profile">Edit Profile</button>
            </div>
            <div className="share-profile">
              <div>Share Your Profile</div>
              <div className="social-icons">
              <FontAwesomeIcon icon={faInstagram} />
                    <FontAwesomeIcon icon={faTwitter} />
                    <FontAwesomeIcon icon={faFacebook} />
              </div>
            </div>
            <Link to='/card' className="share-card">Share Your Own Card...</Link>
          </div>
        </div>
      </div>
      {/* <div className="circle ppurple"></div>
      <div className="circle wwhite"></div>
      <div className="circle ppu"></div>
      <div className="circle whh"></div>
      <div className="circle puur"></div>
      <div className="circle purrr"></div> */}
    </div>
  );
};

export default ProfileCard;
